import {
    Component,
    OnInit
} from '@angular/core';
import {
    Router
} from '@angular/router';
import {
    HTTPService
} from '../Services/http.service';
import {
    Constants
} from '../Services/Constants';
import {
    MySharedService
} from '../App/shared.service'
import {
    filter
} from '../App/search.pipe';


@Component({
    selector: 'menuTemplate',
    templateUrl: '../AppViews/Common/Menu.html'
})

export class SideMenuComponent implements OnInit {

    //called first time before the ngOnInit()
    constructor(
        private _httpService: HTTPService,
        private _router: Router,
        private _sharedService: MySharedService


    ) {
        this.constant = new Constants();
    }


    constant: Constants;
    menuItems: any[];
    userDetail: any;
    public showLoader = false;
    powerBiMenuId:any=0;


    ngOnInit() {

        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.menuItems = JSON.parse(localStorage.getItem("menuItems"));
        if (this.menuItems == null) {
            this.showLoader = true;
            this._httpService.ajaxPost('login/GetSiteUserMenu', {
                "siteUserId": this.userDetail.SiteUserId
            }).subscribe(
                data => {
                    this.menuItems = data["menuItems"];
                    localStorage.setItem("menuItems", JSON.stringify(data["menuItems"]));
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constant.globalError);
                },
                () => {
                    this.checkPageAuthentication();
                }
            );
            this.showLoader = false;
        } else {
            this.checkPageAuthentication();
        }

    }

    public checkPageAuthentication() {

        var currentURI = window.location.href.substr(window.location.href.lastIndexOf('/'));
        if (currentURI == '/changePassword' ||
            (currentURI == '/projects' || currentURI.includes('/projects') == true) ||
            currentURI == '/addTimesheet' ||
            (currentURI == '/editTimesheet' || currentURI.includes('/editTimesheet') == true) ||
            (currentURI == '/invoiceEdit' || currentURI.includes('/invoiceEdit') == true) ||
            (currentURI == '/invoicePrint' || currentURI.includes('/invoicePrint') == true) ||
            currentURI.includes('/siteInfoList') == true ||
            currentURI == '/resourceCost' ||
            currentURI == '/resourceGradeAndCost' ||
            (currentURI == '/vendorsAdd' || currentURI.includes('/vendorsAdd') == true) ||
            (currentURI == '/releaselogs' || currentURI.includes('/releaselogs') == true) ||
            (currentURI == '/releaselogsout' || currentURI.includes('/releaselogsout') == true) ||
            (currentURI == '/vendorEdit' || currentURI.includes('/vendorEdit') == true) ||
            (currentURI == '/MyTaskList' || currentURI.includes('/MyTaskList') == true) ||
            (currentURI == '/MyTask' || currentURI.includes('/MyTask') == true) ||
            (currentURI == '/detailedRatingReport' || currentURI.includes('/detailedRatingReport') == true) ||
            (currentURI == '/detailedPointReport' || currentURI.includes('/detailedPointReport') == true) ||
            (currentURI == '/bugTracker' || currentURI.includes('/bugTrackerEdit') == true) ||
            (currentURI == '/setupKRA' || currentURI.includes('/setupKRA') == true) ||
            (currentURI == '/ReviewEmployeePrint' || currentURI.includes('/ReviewEmployeePrint') == true) ||
            (currentURI == '/reviewSheet' || currentURI.includes('/reviewSheet') == true) ||
            (currentURI == '/Template' || currentURI.includes('/Template') == true) ||
            (currentURI == '/TemplateKRA' || currentURI.includes('/TemplateKRA') == true) ||
            (currentURI == '/ReviewPeriod' || currentURI.includes('/ReviewPeriod') == true) ||
            (currentURI == '/ChangeRequest' || currentURI.includes('/ChangeRequest') == true) ||
            (currentURI == '/ChangeRequestList' || currentURI.includes('/ChangeRequestList') == true) ||
            (currentURI == '/ChangeRequestLink' || currentURI.includes('/ChangeRequestLink') == true) ||
            (currentURI == '/ChangeRequestLinkThankYou' || currentURI.includes('/ChangeRequestLinkThankYou') == true) ||
            (currentURI == '/CheckList' || currentURI.includes('/CheckList') == true) ||
            (currentURI == '/location' || currentURI.includes('/location') == true) ||
            (currentURI == '/multiLocationTask' || currentURI.includes('/multiLocationTask') == true) ||
            (currentURI == '/multiLocationTaskForms' || currentURI.includes('/multiLocationTaskForms') == true) ||
            (currentURI == '/fileUpload' || currentURI.includes('fileUpload') == true) ||
            (currentURI == '/multiLocationTask' || currentURI.includes('multiLocationTask') == true) ||
            (currentURI == '/multiLocationTaskForms' || currentURI.includes('multiLocationTaskForms') == true) ||
            (currentURI == '/vendorView' || currentURI.includes('vendorView') == true) ||
            (currentURI == '/clientView' || currentURI.includes('clientView') == true) ||
            (currentURI == '/installationAdd' || currentURI.includes('/installationAdd') == true) 

        )

        {} else {
            var isMenuAllowed = JSON.parse(JSON.stringify(this.menuItems.filter(m => m.MenuURL == currentURI)));
            if (isMenuAllowed == null || isMenuAllowed == 'undefined' || isMenuAllowed.length == 0) {
                this._router.navigate(['login']);
            }
        }
    }
    public isChildNodeExists(parentId: number) {

         //To hide sub menu for power bi.
         let powerbiMenu = this.menuItems.filter(x=>x.MenuURL=='/powerbiReport');
         if(powerbiMenu.length>0)
             this.powerBiMenuId= powerbiMenu[0].MenuId;
             
        var count = 0;
        var i;
        // if(i != 'undefined')
        // {
        for (i = 0; i < this.menuItems.length; i++) {
            if (this.menuItems[i].ParentId == parentId && parentId!=this.powerBiMenuId) {
                count++;
            }
        }
        if (count > 0) {
            return true;
        } else {
            return false;
        }
        // }
    }

    public logOut() {
        this.showLoader = true;
        this._httpService.ajaxPost('login/Logout', {
            "UserId": this.userDetail.SiteUserId
        }).subscribe(
            data => {
                console.log(data["Status"].Message);
                this._router.navigate(['login']);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);

            },

            () => {
                this.showLoader = false;

            }
        );
    }



}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Layout/sideMenu.component.ts
 **/